module.exports = __webpack_public_path__ + "static/media/8.2854e42f.png";